import { render } from "./DrawLayout.vue?vue&type=template&id=4254d077&ts=true"
import script from "./DrawLayout.vue?vue&type=script&lang=ts"
export * from "./DrawLayout.vue?vue&type=script&lang=ts"

import "./DrawLayout.vue?vue&type=style&index=0&id=4254d077&lang=scss"

import exportComponent from "/var/www/rewards/runners/admin/root/reward-admin/reward-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__